import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, ComboBox, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeleteGroupConfirmationModal = ({ show, onClose, onConfirm, confirming, groupName, groups = [] }) => {
  const { t } = useTranslation()
  const [selectedGroup, setSelectedGroup] = useState('')

  useEffect(() => {
    setSelectedGroup(groups?.[0]?.value)
  }, [groups])

  return (
    <Modal title={t('Eliminar grupo')} size="l" onClose={onClose} show={show}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Elige a qué grupo quieres mover los usuarios del grupo {{groupName}} antes de eliminarlo definitivamente.',
            { groupName }
          )}
        </Text>
        <ComboBox
          label={t('Nuevo grupo')}
          menuItems={groups}
          value={selectedGroup}
          handleChange={e => setSelectedGroup(e.target.value)}
        />
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={() => onConfirm(selectedGroup)}
            defaultLabel={t('Confirmar y eliminar grupo')}
            loadingLabel={t('Confirmando')}
            loading={confirming}
            disabled={!selectedGroup}
            fullWidth
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeleteGroupConfirmationModal
